var _ellipse, _path, _ellipse2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCoedit = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 146,
  height: 100,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 86.781,
  cy: 20.285,
  rx: 19.88,
  ry: 20.028,
  fill: "#0170FC"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M41.787 80.61l17.645-22.573c4.546-5.816 13.346-5.816 17.892 0 4.546 5.816 13.346 5.816 17.892 0 4.547-5.816 13.346-5.816 17.893 0l17.645 22.572c6.158 7.879.545 19.391-9.454 19.391H51.24c-9.999 0-15.612-11.513-9.453-19.39z",
  fill: "#0170FC"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 47.025,
  cy: 26.96,
  rx: 13.254,
  ry: 13.352,
  fill: "#0170FC",
  fillOpacity: 0.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.89 67.394l6.61-7.991c5.11-6.179 14.737-5.666 19.162 1.021a11.943 11.943 0 010 13.182l-5.334 8.06a12 12 0 01-10.007 5.377h-1.185c-10.154 0-15.719-11.825-9.247-19.649z",
  fill: "#0170FC",
  fillOpacity: 0.6
})));
export { SvgCoedit as ReactComponent };